<div class="confirm-container">
  <span mat-dialog-title>{{modalTitle}}</span>
  <div mat-dialog-content>
    <div><b>{{actionMessage}}</b></div>

    @if (warningMessage) {
      <div class="warning-message">
        <mat-icon color="warn">error_outline</mat-icon> {{warningMessage}}
      </div>
    }

    @for (modalInfo of modalInformation; track modalInfo) {
      <ul>
        <li>
          <b>{{modalInfo.title}}: </b>{{modalInfo.info}}
        </li>
      </ul>
    }
  </div>

  <div mat-dialog-actions style="float:right;margin:20px;">
    <button mat-button [mat-dialog-close]="{ clicked: 'Ok' }">{{confirmButton}}</button>
    <button mat-button [mat-dialog-close]="{ clicked: 'Cancel' }">
      Cancel
    </button>
  </div>
</div>
